import { fetchPropertyOfferMap } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

type Return = [
  mapping: App.PropertyOfferMapping | undefined,
  fetching: boolean,
  error: any,
]

function usePropertyOfferMapping(
  propertyId: string | undefined = '',
  options: { disabled?: boolean } = {},
): Return {
  const dispatch = useAppDispatch()

  const mapping = useAppSelector(state => state.offer.propertyOfferMappings[propertyId])

  useEffect(() => {
    if (!options.disabled && propertyId) {
      dispatch(fetchPropertyOfferMap(propertyId))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId, options.disabled])

  return [
    mapping?.mapping,
    mapping?.fetching ?? !options.disabled,
    mapping?.error,
  ]
}

export default usePropertyOfferMapping
